import axios from 'axios'
import Global from '../Global'
import { sessionHeader } from './main.api'

export default class FileApi {
    constructor(){}

    static initUpload(file_name, file_size, parent_id) {    
        let data = {
            "file_name": file_name,            
            "file_size": file_size,
            "parent_id": parent_id,            
        }                               // returns file_id
        return axios
        .post(Global.GetAPIURL() + '/file/upload_start', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }
   
    static addChunk(file_id, data) {
       let ChunkSessionHeader = {
            headers:{
                "session_id": sessionHeader.headers.session_id,
                "file-id" : file_id
            }
          }
        return axios.
        post(Global.GetDomainURL() + '/upload', data, ChunkSessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static finishUpload(file_id) {    
        let data = {
            "file_id": file_id,            
        }   
        return axios
        .post(Global.GetAPIURL() + '/file/upload_finish', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })     
    }
    
    static CancelUpload(file_id) {    
        let data = {
            "file_id": file_id,            
        }   
        return axios
        .post(Global.GetAPIURL() + '/file/upload_cancel', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })     
    }

    static MyBrokenUploads() {            
        return axios
        .get(Global.GetAPIURL() + '/file/get_unfinished_uploads', sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })    
    }

    static downloadFile(file_id, file_name, folder_id, view= false){
        let data = {
            "file_id": file_id,                        
            "file_name": file_name,      
            "folder_id": folder_id,
            "v2": true,
            "view": view
        }
        return axios
        .post(Global.GetAPIURL() + '/file/get_link', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }


    static getOffice(file_id, file_name, folder_id){
        let data = {
            "file_id": file_id,                        
            "file_name": file_name,      
            "folder_id": folder_id,
            "for_online_office": true
        }
        return axios
        .post(Global.GetAPIURL() + '/file/get_link', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static Preview(file_id){
        let data = {
            "file_id": file_id,                        
        }
        return axios
        .post(Global.GetAPIURL() + '/file/preview', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static ViewFile(token_id){
        let data = {
            "token_id": token_id,    
            "op": "view"     
        }
        return axios
        .post(Global.GetAPIURL() + '/file/operation', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static EditFile(token_id){
        let data = {
            "token_id": token_id,    
            "op": "edit"     
        }
        return axios
        .post(Global.GetAPIURL() + '/file/operation', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static Details(file_id, channel_id){
        let data = {
            "file_id": file_id,       
            "channel_id": channel_id                 
        }
        return axios
        .post(Global.GetAPIURL() + '/file/details', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

}